import { useButton } from '@react-aria/button';
import * as React from 'react';
import { useSwanMenuTriggerContext } from './menu-trigger.context.js';
import { useSwanPopover } from '../popover/popover.context.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * @subcomponent Menu
 */ function MenuTrigger({ children }) {
    const { triggerRef } = useSwanPopover();
    const { triggerProps } = useSwanMenuTriggerContext();
    const { buttonProps } = useButton(triggerProps, triggerRef);
    // we don't want react-aria's disabled state to come through; we want the child element to control its own disabled state
    // typescript is complaining disabled isn't on FocusableElement, but it's coming from useButton
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const filteredButtonProps = _object_without_properties(buttonProps, [
        "disabled"
    ]);
    const newProps = _object_spread_props(_object_spread({}, filteredButtonProps), {
        ref: triggerRef,
        type: undefined
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, React.Children.map(children, (child, index)=>{
        if (index === 0 && /*#__PURE__*/ React.isValidElement(child)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const combinedRefs = assignRefs(triggerRef, child.ref);
            return /*#__PURE__*/ React.cloneElement(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            child, _object_spread_props(_object_spread({}, newProps), {
                ref: combinedRefs
            }));
        }
        return child;
    }));
}

export { MenuTrigger };
